import React, {useContext, useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {HTTP_STATUS_OK} from '../../../smartpak/httpstatus';
import {BridleContext} from './../BridleContextProvider';

const BridleCards = () => {
    const {styles, setStyles, setOptions, defaultOptions} = useContext(BridleContext);
    const [bridleStyle, setBridleStyle] = useState();
    const imageSizes = {
        mobileResponsiveWidth: 288,
        desktopWidth: 276,
        desktopResponsiveWidth: 552
    };
    const navigate = useNavigate();
    const siteHeader = document.querySelector('.site-header');
    const siteFooter = document.querySelector('.site-footer');

    siteHeader.style.display = 'block';
    siteFooter.style.display = 'block';

    function calculateimageSizes(url, width) {
        return 'https://img.smartpak.com/images/product/highres/' + url + '?w=' + width;
    }
    function createMarkup(text) {
        return {__html: text};
    }

    function handleSelection(product) {
        siteHeader.style.display = 'none';
        siteFooter.style.display = 'none';

        if (!!styles && styles.id !== product.id) {
            setOptions(defaultOptions);
        }
        setStyles(product);
        navigate('/color');
    }

    useEffect(() => {
        fetch('/api/bundlebuilder/getbridlestyles')
            .then(response => response.json())
            .then(results => {
                if (results.status === HTTP_STATUS_OK) {
                    setBridleStyle(results);
                }
            });
    }, []);

    return (
        <div className="grid-product bridle-products">
            <span className="empty-cell">&nbsp;</span>
            {bridleStyle &&
                bridleStyle.content.map((item, index) => {
                    return (
                        <div key={index} className="card-product" onClick={() => handleSelection(item)} role="link">
                            <div className="card-title" dangerouslySetInnerHTML={createMarkup(item.name)}></div>
                            <div className="card-details">
                                <div className="card-price">{item.priceRange}</div>
                            </div>
                            <div className="card-image">
                                <picture>
                                    <source
                                        width="144"
                                        height="144"
                                        media="(max-width: 767px)"
                                        srcSet={calculateimageSizes(item.thumbnail, imageSizes.mobileResponsiveWidth)}
                                    />
                                    <source
                                        width="276"
                                        height="276"
                                        media="(min-width: 768px)"
                                        srcSet={calculateimageSizes(item.thumbnail, imageSizes.desktopWidth)}
                                    />
                                    <source
                                        width="276"
                                        height="276"
                                        media="(min-width: 768px), (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)"
                                        srcSet={calculateimageSizes(item.thumbnail, imageSizes.desktopResponsiveWidth)}
                                    />
                                    <img
                                        width="144"
                                        height="144"
                                        src={calculateimageSizes(item.thumbnail, imageSizes.mobileResponsiveWidth)}
                                        alt={item.name}
                                        role="presentation"
                                    />
                                </picture>
                            </div>
                        </div>
                    );
                })}
            <span className="empty-cell">&nbsp;</span>
        </div>
    );
};
export default BridleCards;
